<template>
  <div class="song-request">
    <div class="main-title">使用帮助/互动功能/点歌</div>
    <h1 class="page-title">点歌</h1>
    <h4 class="content-text">（1）首先需要在后台活动信息中设置下歌手信息，歌单详情等。</h4>
    <img
      src="https://ustatic.hudongmiao.com/miao/common/help-songrequest1_17682876174306a33a4.webp"
      alt="酒吧大屏互动酒吧歌手设置"
      class="example-image"
    />
    <img
      src="https://ustatic.hudongmiao.com/miao/common/help-songrequest2_1768287617431b4bf68.webp"
      alt="酒吧大屏互动酒吧歌手设置"
      class="example-image"
    />
    <h4 class="content-text">（2）然后进入大屏，找到小游戏，点开驻场音乐。</h4>
    <img
      src="https://ustatic.hudongmiao.com/miao/common/help-songrequest3_176828761743136c157.webp"
      alt="酒吧大屏互动驻场音乐"
      class="example-image"
    />
    <h4 class="content-text">（3）打开右下角二维码，让用户扫码进入，在手机端点歌。</h4>
    <img
      src="https://ustatic.hudongmiao.com/miao/common/help-songrequest4_176828761743138cd3e.webp"
      alt="酒吧大屏互动扫码点歌"
      class="example-image"
    />
    <h4 class="content-text">（4）手机端点击"点歌台"，选择对应的歌曲，支付即可，大屏端与手机端已点歌曲实时展示。</h4>
    <img
      src="https://ustatic.hudongmiao.com/miao/common/help-songrequest5_17682876174316458e9.webp"
      alt="酒吧大屏互动点歌打赏"
      class="mobile-image"
    />
    <img
      src="https://ustatic.hudongmiao.com/miao/common/help-songrequest6_17682876174318628c4.webp"
      alt="酒吧大屏互动点歌打赏"
      class="mobile-image"
    />
    <img
      src="https://ustatic.hudongmiao.com/miao/common/help-songrequest7_1768287617431f79d79.webp"
      alt="酒吧大屏互动点歌打赏"
      class="mobile-image"
    />
    <img
      src="https://ustatic.hudongmiao.com/miao/common/help-songrequest8_1768287617431f271ad.webp"
      alt="酒吧大屏互动点歌打赏"
      class="mobile-image"
    />
  </div>
</template>

<script>
export default {
  name: 'SongRequest',
};
</script>

<style lang="less" scoped>
.song-request {
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
}

.main-title {
  width: 100%;
  font-weight: 500;
  font-size: 20px;
  color: #E19BFF;
  text-align: left;
  margin-top: 10px;
  padding-bottom: 12px;
  border-bottom: 1px solid #E19BFF;
}

.page-title {
  width: 100%;
  font-weight: 700;
  font-size: 32px;
  color: #FFFFFF;
  text-align: left;
  margin-top: 10px;
}

.content-text {
  width: 100%;
  font-weight: 400;
  font-size: 15px;
  color: #FFFFFF;
  text-align: left;
  word-wrap: break-word;
  word-break: break-all;
  margin-top: 10px;
}

.mobile-image {
  width: 241px;
  height: auto;
  margin: 10px auto;
  display: block;
}

.example-image {
  width: 100%;
  height: auto;
  margin-top: 10px;
  margin-bottom: 10px;
}
</style>
